module.exports = __webpack_public_path__ + "static/img/送气-act.69bd19b2.png";